import React, { useState } from 'react'
import CalculatorForm from '../../../components/CalculatorForm'
import RsuVestInputs from '../../../components/RsuVestInputs'
import { useWizardStore } from '../store'
import PeriodInput from '../components/PeriodInput'
import { Collapse } from 'antd'

export default function StepIncome() {
  const [benefitsOpen, setBenefitsOpen] = useState(false)
  const selectedTaxYear = useWizardStore((s) => s.selectedTaxYear)
  const inputs = useWizardStore((s) => s.inputs)
  const setInputs = useWizardStore((s) => s.setInputs)
  const setRsuVestEvents = useWizardStore((s) => s.setRsuVestEvents)
  const setEmployerNicLiable = useWizardStore((s) => s.setEmployerNicLiable)

  const handleAnnualChange = (name, annualisedValue) => {
    setInputs({ [name]: annualisedValue })
  }

  const handleInputChange = (name, value) => {
    setInputs({ [name]: value })
  }

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-xl font-semibold">Income & Benefits</h2>
        <p className="text-sm text-gray-600">Switch between monthly and annual. We’ll convert for you.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <PeriodInput
          name="baseSalary"
          label="Base Salary (£)"
          tooltip="Gross salary before tax and pension contributions"
          valueAnnual={Number(inputs.baseSalary) || 0}
          onAnnualChange={handleAnnualChange}
          step={100}
        />
        <PeriodInput
          name="bonus"
          label="Bonus / Commission (£)"
          tooltip="Expected bonus or commission for the tax year"
          valueAnnual={Number(inputs.bonus) || 0}
          onAnnualChange={handleAnnualChange}
          step={100}
        />
        <PeriodInput
          name="medicalBenefit"
          label="Medical Benefit (BIK) (£)"
          tooltip="Taxable medical insurance benefit (from payslip ×12 if monthly)"
          valueAnnual={Number(inputs.medicalBenefit) || 0}
          onAnnualChange={handleAnnualChange}
          step={10}
        />
        <PeriodInput
          name="voldeductions"
          label="Voluntary Deductions (£)"
          tooltip="Sum total across dental, life insurance and other voluntary deductions (×12 if monthly)"
          valueAnnual={Number(inputs.voldeductions) || 0}
          onAnnualChange={handleAnnualChange}
          step={10}
        />
      </div>

      <div className="bg-gray-50 border rounded p-4 text-sm text-gray-700">
        <strong>Where to find these numbers</strong>
        <ul className="list-disc pl-5 mt-2 space-y-1">
          <li><strong>Monthly Payslip:</strong> Basic pay, bonus (if paid), Medical Benefit (BIK), Pension %</li>
          <li><strong>Benefits Portal:</strong> Medical benefit value, voluntary deductions</li>
          <li><strong>Contract:</strong> Annual base salary figure</li>
        </ul>
      </div>

      <div className="space-y-3">
        <h3 className="text-lg font-medium">Pension Contributions</h3>
        <CalculatorForm
          inputs={inputs}
          onInputChange={handleInputChange}
          onReset={() => window.location.reload()}
          showTitle={false}
          showBaseSalary={false}
          showBonus={false}
          showMedicalBenefit={false}
          showVoluntaryDeductions={false}
          showEmployeePensionContribution={true}
          showEmployerMaxPensionContribution={true}
          colProps={{ xs: 24, sm: 12, md: 12 }}
        />
      </div>

      <Collapse activeKey={benefitsOpen ? ['1'] : []} onChange={() => setBenefitsOpen((v) => !v)}>
        <Collapse.Panel header="Additional Benefits & Salary Sacrifice Schemes (optional)" key="1">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <PeriodInput
              name="childcareVouchers"
              label="Childcare Vouchers (£/month)"
              tooltip="Monthly childcare voucher amount (salary sacrifice). We annualise this for calculations."
              valueAnnual={Number(inputs.childcareVouchers) || 0}
              onAnnualChange={handleAnnualChange}
              step={10}
            />
            <PeriodInput
              name="cycleToWork"
              label="Cycle to Work (£/year)"
              tooltip="Annual value of cycle to work salary sacrifice"
              valueAnnual={Number(inputs.cycleToWork) || 0}
              onAnnualChange={handleAnnualChange}
              step={50}
            />
            <PeriodInput
              name="electricCar"
              label="Electric Car Scheme (£/month)"
              tooltip="Monthly electric vehicle salary sacrifice amount"
              valueAnnual={Number(inputs.electricCar) || 0}
              onAnnualChange={handleAnnualChange}
              step={10}
            />
            <PeriodInput
              name="companyCarBenefit"
              label="Company Car Benefit (P11D) (£/year)"
              tooltip="Annual P11D value of company car benefit (adds to taxable income)"
              valueAnnual={Number(inputs.companyCarBenefit) || 0}
              onAnnualChange={handleAnnualChange}
              step={100}
            />
          </div>
        </Collapse.Panel>
      </Collapse>

      <div className="mt-6 space-y-2">
        <div className="flex items-center justify-between">
          <h3 className="text-lg font-medium">Restricted Stock Units (RSUs)</h3>
          <button
            className="px-3 py-2 border rounded"
            onClick={() => setRsuVestEvents([])}
          >
            Reset RSUs
          </button>
        </div>
        <p className="text-sm text-gray-600">Not sure if you need this? RSUs are company shares vesting over time and are taxed as income when they vest.</p>
        <RsuVestInputs
          vestEvents={inputs.rsuVestEvents}
          onChange={(events) => setRsuVestEvents(events)}
          taxYear={selectedTaxYear}
          isTaxResidentInScotland={inputs.isTaxResidentInScotland}
          isEmployerNicLiable={inputs.isEmployerNicLiable}
          onEmployerNicLiableChange={(v) => setEmployerNicLiable(v)}
        />
      </div>
    </div>
  )
} 